import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import { mergeWith } from 'lodash';
import Actions from "../../../Actions";
import Form from "./Form";
import Tile from "../Layout/Tile";

class Edit extends Component{
    constructor(props){
        super(props);
        this.modalRef = false;
    }

    componentDidUpdate(){
        const { jobStore: { alert: { edit }, jobSubmitted } } = this.props;
        if(edit && !jobSubmitted && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }

    customizer = ( src, other ) => {
        return src === null || src === undefined ? other: src; 
    }

    render = () => {
        const { jobStore: { alert: { edit } }, modalStore: { edit: { modal, data} }, editJob, toggleModal } = this.props;
        const editData = !data ? {} : data;
        mergeWith(editData, {type: {id : ""}, location: { id: ""}, assignee: {id: ""}, sub_location: {id: ""}, user: { id: ""}},this.customizer);
        const { type : { id: type } , location : { id: location }, location_meta : locationMeta = "", status = "", assignee : { id: assigned_to } , sub_location : { id: subLocation = "" }, problem = "", priority = "", HS = 0, comment = "", vanity_id:id, image = false, created_at = "", user: { id: created_by }, creation_timestamp = "", updated_at = ""  } = editData;
        const editedData = { type, location, locationMeta, status, assigned_to, subLocation, problem, priority, HS, comment, image, created_by, created_at, creation_timestamp, updated_at };
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("jobs","edit")}>
                    <ModalHeader toggle={() => toggleModal("jobs","edit")}>Edit Job #{id}</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {edit !== false &&
                                    <Alert color={edit.type}>
                                        { edit.message }
                                    </Alert>                                         
                                }
                                <Form data={editedData} id={id} persist={editJob} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    jobStore: state.jobStore,
    modalStore: state.modalStore.jobs,
});

const { jobs, modals } = Actions;

export default connect(mapStateToProps, { ...jobs, ...modals })(Edit);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/Edit.js